module.exports = __webpack_public_path__ + "static/media/scale.ef1e6908.svg";